import styled from 'styled-components';
import { GlobalToken } from 'antd';
import { CustomThemeToken } from '@/theme/theme.utils';

export const PromptCardContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingLG}px;
  background-color: ${({ theme: { token } }) => (token as CustomThemeToken).colorPrimaryGrDark || '#1b2d43'};
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  min-height: 126px;
  width: 255px;
  flex-shrink: 0;
  gap: 2px;
  transform: translateZ(0);
  will-change: transform;

  &:hover {
    transform: translateY(-2px) translateZ(0);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const PromptIconWrapper = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 32px;
  width: 68px;
  padding: ${({ theme: { token } }) => token.padding * 1.8}px 0;
`;

export const PromptIconCircle = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 41.48px;
  height: 30.5px;
`;

export const PromptCardContent = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 6px;
  width: 100%;
`;

export const PromptText = styled.span<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorTextBase || token.colorText || '#000000'};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  text-align: left;
`;
//  line-height: ${({ theme: { token } }) => token.lineHeight}px;

export const PromptSubtext = styled.span<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorTextDescription || token.colorTextSecondary || 'rgba(0, 0, 0, 0.45)'};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  line-height: 24px;
  text-align: left;
`;
